import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Reservations } from './reservation.model';
import { environment } from './../../environments/environment';

@Injectable()
export class ReservationService {

  constructor(private httpClient: HttpClient) {}

  items(query: any): Observable<Reservations> {
    const params = new HttpParams({fromObject: query});
    params['front'] = true;
    return this.httpClient.get<Reservations>(environment.api + '/forms', { params: params });
  }

  public save(data: any): Observable<any> {
    return this.httpClient.post(environment.api + '/reservation', data);
  }

  public reservations(id: number): Observable<any> {
    return this.httpClient.get<any>(environment.api + '/reservations/' + id);
  }

}

